import { shallowEqual, useSelector } from 'react-redux';
import { getExperiences } from '../selectors';

export const useExperiences = () => ({
  experiences: useSelector(getExperiences, shallowEqual),
});
